'use strict';

import React, { useCallback, useEffect, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/FrontOffice'

import FrontAuthCentered from '@/Wrapper/FrontAuthCentered'

import RegistrationConfirmationForm from '@/Form/RegistrationConfirmationForm'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

import logRequestError from '@function/ajax/logRequestError'
import request         from '@function/ajax/request'

import { isTrue } from '@root/utility'

const success_msg = 'Inscription effectuée. Vous pouvez maintenant vous connecter via le formulaire de connexion.';

export default PageWrapper(function RegistrationConfirmationPage (props)
{
	const [phone_required, setPhoneRequired] = useState(false);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [status, setStatus] = useState({ fields: { } });
	const [user, setUser] = useState();

	const token = document.location.pathname
	.slice(document.location.pathname.lastIndexOf('/')+1);

	useEffect(function ()
	{
		setLoading(true);

		(async function ()
		{
			try
			{
				var response = await request('/user/get-from-token')
				.config({ keyword: 'action' })
				.post({ token: token });
			}
			catch (update)
			{
				return setStatus(update);
			}
			finally
			{
				setLoading(false);
			}

			setUser(response.user);
			setPhoneRequired(isTrue(response.require_phone));
		})();
	},
	[token]);

	const handleSubmit = useCallback(function (e, form_data)
	{
		setLoading(true);

		(async function ()
		{
			try
			{
				await request('/registration-confirmation')
				.config({ keyword: 'action', timeout: 12 * 1000 })
				.post(form_data);
			}
			catch (update)
			{
				logRequestError();

				return setStatus(update);
			}
			finally
			{
				setLoading(false);
			}

			setStatus({ info: success_msg });

			setSuccess(true);
		})();
	},
	[]);

	const loader = loading === true ?
	(
		<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
	)
	: undefined;

	return (
		<Layout page_title="Confirmation d'inscription">

			<FrontAuthCentered>

				<div className="home-form registration">

					<div className="home-form__img-container">
						<Image className="home-form__img"
							src="/images/background/accueil_synergies@1500.jpg" alt=""
						/>
					</div>

					<RegistrationConfirmationForm key={ token }
						token={ token } user={ user }
						className="c-form form-registration"
						history={ props.history }
						loading={ loading }
						status={ status }
						setStatus={ setStatus }
						onSubmit={ handleSubmit }
						success={ success }
						phone_required={ phone_required }
					/>

					{
						success !== true ?
						(
							<Link className="form-goto-home" href="/login">
								Page de connexion
							</Link>
						)
						: undefined
					}

					{ loader }

				</div>

			</FrontAuthCentered>

		</Layout>
	);
});